import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeIframeHtml',
})
export class SafeIframeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(content: string): SafeResourceUrl {
    const isHtml = content.startsWith('<!DOCTYPE');
    const contentToSanitize = isHtml ? content : content.replace(/\n/g, '<br/>');

    return this.sanitizer.bypassSecurityTrustHtml(this.sanitizer.sanitize(SecurityContext.HTML, contentToSanitize));
  }
}
